//import '../components/UI/UIElements/UIElements.less';
import '../js/core/polyfills';

import axios from 'axios';
import 'simplebar'; // or "import SimpleBar from 'simplebar';" if you want to use it manually.
import 'simplebar/dist/simplebar.css';

import { getLang } from "../js/core/Helpers/Helpers";

class Page {
	
    constructor(){
        
        let langAddress = `cache/_translations/${getLang()}.json`;
        
        let lang = axios.get(langAddress);
    
        lang.then(response => {
            localStorage.setItem('lang', JSON.stringify(response.data));
        
        }).catch(error => {
            error.response.status === 404
                ? console.log('[Sorry, we could not get language file. Something went wrong.]', error.response.status)
                : console.log('[Something is wrong with language processing.]');
        });
    }
    
}

export default Page;


// WEBPACK FOOTER //
// ./extendable/Page.js